/**
 * `pool_metadata.pool_id` for v2 grids — must stay aligned with
 * {@link gridMetaKey} in `lib/cache/metadata.ts`.
 */
export function gridPoolMetadataId(compositeGridId: string, managerAddress: string): string {
  return `v2grid-${managerAddress.toLowerCase()}-${compositeGridId}`;
}

/**
 * Validate a `pool_metadata.pool_id` lookup key. Accepts:
 *  - V1 pool addresses: `^0x[a-f0-9]+$` (Uniswap pool address).
 *  - V2 grid keys:      `^v2grid-…` (any well-formed `gridMetaKey()`
 *                       output — manager-prefixed or legacy bare).
 *
 * Anything else (bare numeric ids, `{ugm}-{numericId}` composites
 * without the `v2grid-` prefix, free-form strings) is rejected so
 * accidental callers can't silently miss every V2 row by passing an
 * unprefixed gridId. Mirrors the storage shape every writer in this
 * codebase produces via `gridMetaKey()` / `gridPoolMetadataId()`.
 */
const POOL_KEY_V1_RE = /^0x[a-f0-9]+$/i;
const POOL_KEY_V2_RE = /^v2grid-[a-f0-9x\-]+$/i;
export function isValidPoolMetadataKey(key: string): boolean {
  return POOL_KEY_V1_RE.test(key) || POOL_KEY_V2_RE.test(key);
}
